// Abas da tela SMS do Super Master (2026-10-03): Migração, Vincular
// veículos e Completar dados saíram do menu de cima e viraram abas aqui.
// Cada aba continua sendo sua própria rota — só a navegação mudou.
import { Link, useRouterState } from "@tanstack/react-router";
import { ArrowRightLeft, Link2, MessageSquare, Wand2 } from "lucide-react";
import { cn } from "@/lib/utils";

export const SMS_TABS = [
  { to: "/master/sms", label: "Créditos SMS", icon: MessageSquare },
  { to: "/master/migration", label: "Migração", icon: ArrowRightLeft },
  { to: "/master/vehicle-link", label: "Vincular veículos", icon: Link2 },
  { to: "/master/vehicle-fill", label: "Completar dados", icon: Wand2 },
] as const;

export function MasterSmsTabs() {
  const pathname = useRouterState({ select: (r) => r.location.pathname });
  return (
    <div className="border-b bg-background">
      <div className="mx-auto flex max-w-7xl gap-1 overflow-x-auto px-6 pt-3">
        {SMS_TABS.map((t) => {
          const active = pathname === t.to;
          return (
            <Link
              key={t.to}
              to={t.to}
              className={cn(
                "flex shrink-0 items-center gap-1.5 border-b-2 px-3 pb-2 text-sm font-medium transition-colors",
                active ? "border-primary text-foreground" : "border-transparent text-muted-foreground hover:text-foreground",
              )}
            >
              <t.icon className="h-4 w-4" /> {t.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
